import React, { CSSProperties } from 'react';
import styles from './highlightText.module.scss';

type Props = {
	text: string;
	highlightText: string;
	highlightStyle: CSSProperties;
	invert?: boolean;
};

const HighlightText: React.FC<Props> = ({ text, highlightText, highlightStyle, invert = false }) => {
	const onEscapeSpecialChars = (txt: string) => {
		return txt.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	};

	const parts = text.split(new RegExp(`(${onEscapeSpecialChars(highlightText)})`, 'gi'));

	return (
		<p className={styles.paragraph}>
			{parts.map((part, index) => {
				const isHighlight = part.toLowerCase() === highlightText.toLowerCase();
				if (invert) {
					return isHighlight ? (
						<span key={index}>{part}</span>
					) : (
						<span key={index} style={highlightStyle}>
							{part}
						</span>
					);
				} else {
					return isHighlight ? (
						<span key={index} style={highlightStyle}>
							{part}
						</span>
					) : (
						part
					);
				}
			})}
		</p>
	);
};

export { HighlightText };
